import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { createLogger } from 'redux-logger';
import { batchDispatchMiddleware } from 'redux-batched-actions';
import { routerMiddleware } from 'connected-react-router';

import generateReducers from '../reducers';
import generateSagas from '../sagas';

const loggerMiddleware = createLogger();
const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState, history) {
  const middleware = [
    batchDispatchMiddleware,
    sagaMiddleware,
    routerMiddleware(history),
  ];

  let composeEnhancers = compose;

  if (process.env.NODE_ENV === 'development') {
    // middleware.push(loggerMiddleware);
  }

  if (typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__)
    composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({});

  const enhancers = [applyMiddleware(...middleware)];

  const store = createStore(
    generateReducers(history),
    initialState,
    composeEnhancers(...enhancers)
  );
  sagaMiddleware.run(generateSagas(history));

  return store;
}
